export default function genererDataBonExpedition() {
  return {
    dateBonExpedition: new Date(),
    adresseExpedition: null,
    clientId: null,
    instructionDeLivraison: null,
    contactDestinataireId: null,
    nomContactDestinataire: null,
    prenomContactDestinataire: null,
    emailContactDestinataire: null,
    numTelephoneContactDestinataire: null,
    nombreElementColis: null,
    poidsParColis: 3,
    adresseExpediteur: null,
    emailExpediteur: null,
    lienTracking: null,
    contactExpediteurId: null,
    societeId: null,
  };
}
